import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Toaster } from './ui/Toasts';
import { useModelsStore } from '../store/modelsStore';

export function Layout() {
  const loadModels = useModelsStore((s) => s.load);
  // Carrega o catálogo de modelos uma vez (rótulos + permitidos) para toda a app.
  useEffect(() => {
    loadModels();
  }, [loadModels]);

  return (
    <div className="flex h-screen overflow-hidden bg-cloud">
      <Sidebar />
      <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
      <Toaster />
    </div>
  );
}
